import { useState, useRef } from 'react'

function ProductDetailPage(props) {
  const [mainImage, setMainImage] = useState(
    'https://placeimg.com/640/480/arch'
  )

  const handleThumbnailClick = (event) => {
    const newImage = event.target.src
    // console.log(newImage)
    setMainImage(newImage)
  }

  const imgRef = useRef(null)

  const handleClick = () => {
    const src = imgRef.current.getAttribute('src')
    console.log(src)
  }

  return (
    <div className='flex'>
      <div className='w-1/2'>
        <img
          src={mainImage}
          className='w-full rounded-xl'
          value={mainImage}
          alt='Cambria'
        />
        <div className='mt-4 space-x-8'>
          <img
            src='https://placeimg.com/640/480/arch'
            className='w-16 h-16 cursor-pointer inline-block rounded-md'
            onClick={handleThumbnailClick}
            alt='Cambria'
          />
          <img
            ref={imgRef}
            src='https://placeimg.com/640/480/tech'
            className='w-16 h-16 cursor-pointer inline-block rounded-md'
            onClick={handleThumbnailClick}
            alt='Cambria'
            onError={(e) => (e.target.style.display = 'none')}
          />
          <img
            src='/images/Portrush.jpg'
            className='w-16 h-16 cursor-pointer inline-block rounded-md'
            onClick={handleThumbnailClick}
            alt='Cambria'
            onError={(e) => (e.target.style.display = 'none')}
          />

          <img
            src=''
            className='w-16 h-16 cursor-pointer inline-block rounded-md'
            onClick={handleThumbnailClick}
            alt='Cambria'
            onError={(e) => (e.target.style.display = 'none')}
          />
        </div>
      </div>
    </div>
  )
}

export default ProductDetailPage
